import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { filterEmptyStrings } from '@utils/utils';

@Directive({})
export class BaseForm {
  @Input() isSaving = false;
  @Input() form = new UntypedFormGroup({});
  @Input() recordData?: any;
  @Output() readonly valueChanges = new EventEmitter();
  protected readonly filterEmptyStrings = filterEmptyStrings;

  constructor(protected readonly fb?: FormBuilder) {}

  isControlRequired(formControlName: string): boolean {
    return this.form.get(formControlName).hasValidator(Validators.required);
  }

  isControlValid(controlName: string, form: AbstractControl = this.form): string | undefined {
    const control: AbstractControl = form.get(controlName);
    if (control.enabled && control.invalid && control.touched) {
      return 'is-invalid';
    }
  }

  shouldDisplayTypeOfError(formControlName: string, errorType: string, form?: AbstractControl): boolean {
    let formControl: AbstractControl;
    if (form) {
      formControl = form.get(formControlName);
    } else {
      formControl = this.form.get(formControlName);
    }
    return formControl.hasError(errorType) && formControl.touched;
  }

  emitFormValue(): void {
    this.form.markAllAsTouched();
    if (this.form.valid && !this.isSaving) {
      this.valueChanges.emit(this.form.value);
    }
  }

  setFormData(): void {
    this.recordData ? this.fillFormWithExistingRecordData() : this.fillFormWithNewRecordData();
  }

  removeWhitespaces(formControl = this.form.get('symbol') as FormControl<string>): void {
    if (formControl.value) {
      formControl.setValue(formControl.value.replace(/\s+/g, ''));
    }
  }

  protected fillFormWithExistingRecordData(): void {
    this.form.patchValue(this.recordData);
  }

  protected fillFormWithNewRecordData(): void {}
}
